import callApi from "./callApi";
export const getConfigurations = async (entityType, projectId) => {
  const url = `plugin/entities/${entityType}?projectId=${projectId}`;
  return await callApi(url, {}, "GET");
};

export const addEntity = async (entity, currentProject) => {
  const url = `plugin/entities?projectId=${currentProject}`;
  return await callApi(url, {}, "POST", entity);
};

export const updateEntity = async (id, entity) => {
  const url = `plugin/entities/${id}`;
  return await callApi(url, {}, "PUT", entity);
};

export const deleteEntity = async (id) => {
  const url = `plugin/entities/${id}`;
  return await callApi(url, {}, "DELETE");
};

export const getTestCaseData = async (projectId) => {
  const url = `testcases/test-case-data?projectId=${projectId}`;
  return await callApi(url, {}, "GET");
};

export const getTestCycleData = async (projectId) => {
  const url = `testcycles/test-cycle-data?projectId=${projectId}`;
  return await callApi(url, {}, "GET");
};

export const checkEntityBeforeDelete = async (entityId) => {
  const url = `testcases/entities/check-before-delete/${entityId}`;
  return await callApi(url, {}, "GET");
}

export const getFieldConfigurations = async (projectId) => {
  const url = `configurations?projectId=${projectId}`;
  return await callApi(url, {}, "GET");
};

export const addField = async (payload) => {
  const url = `configurations`;
  const body = {
    ...payload
  }
  return await callApi(url, {}, "POST", body);
};

export const updateField = async (id, payload) => {
  const url = `configurations/update/${id}`;
  const body = {
    ...payload
  }
  return await callApi(url, {}, "PUT", body);
}

export const deleteField = async (id) => {
  const url = `configurations/delete/${id}`;
  return await callApi(url, {}, "DELETE");
};

export const getUserRolesList = async ({
  scope,
  includePermissions = false,
} = {}) => {
  const params = new URLSearchParams();
  if (scope) {
    params.append('scope', scope);
  }
  if (includePermissions) {
    params.append('includePermissions', 'true');
  }
  const queryString = params.toString();
  const url = `roles/list${queryString ? `?${queryString}` : ''}`;

  return await callApi(url, {}, 'GET');
};

export const getUserPermissionsList = async ({ scope, feature, search, page, perPage } = {}) => {
  const params = new URLSearchParams();

  if (scope) params.append('scope', scope);
  if (feature) params.append('feature', feature);
  if (search) params.append('search', search);
  if (page) params.append('page', page);
  if (perPage) params.append('perPage', perPage);

  const url = `roles/permissions${params.toString() ? `?${params.toString()}` : ''}`;
  
  return await callApi(url, {}, 'GET');
};

export const upsertOrgRole = async ({ roleId, name, desc, perms, scope }) => {
  const body = {name, scope, description: desc, permissionIds: perms };
  if (roleId) body.roleId = roleId;
  return callApi('roles/upsert', {}, 'POST', body);
};
export const deleteOrgRole = async ({ roleId, reassignments = [] }) => {
  const url = `roles/delete/${roleId}`;
  return callApi(url, {}, 'DELETE', { reassignments });
};

export const createPermission = async ({ name, feature, action, scope, description }) => {
  const url= `roles/permissions`
  const body ={ name, feature, action, scope, description}
  return callApi(url, {}, 'POST', body);
};

export const updatePermission = async (permissionId, { name, feature, action, scope, description }) => {
   const url = `roles/permissions/${permissionId}`
   const body = { name, feature, action, scope, description}
  return callApi(url, {}, 'PUT', body);
};

export const getRoleAssignedUsers = async (roleId) => {
   const url =`roles/${roleId}/assigned-users`
  return callApi(url, {}, 'GET');
};